<template>
  <div class="mt-4">
    <v-alert :color="alertColor" :icon="alertIcon" text dense>
      <div class="d-flex flex-wrap justify-space-between align-center">
        <div>
          <div class="font-weight-bold">Estado revisión: {{ estadoTexto }}</div>
          <div v-if="fechaRevision" class="text-caption mt-1">Revisado el: {{ fechaRevision }}</div>
          <div v-if="nombreRevisor" class="text-caption">Por: {{ nombreRevisor }}</div>
          <div v-if="observaciones" class="text-caption mt-1"><strong>Observaciones:</strong> {{ observaciones }}</div>
        </div>

        <v-btn
          v-if="documentoPersona.archivoRespaldoId"
          class="ma-1"
          color="primary"
          outlined
          small
          title="Ver respaldo adjunto"
          @click="verRespaldoGuardado">
          <v-icon small>mdi-eye</v-icon>

          Ver Respaldo
        </v-btn>
      </div>
    </v-alert>

    <v-dialog v-model="dialogoRespaldo" max-width="600px">
      <v-card>
        <v-card-title class="primary--text">
          <span> Vista Previa del Respaldo </span>

          <v-spacer></v-spacer>

          <v-btn icon @click="dialogoRespaldo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <ImagenPreview v-if="esImagen" :src="previsualizacion" nombre-archivo="Respaldo" />
          <PdfPreview v-else-if="esPDF" :src="previsualizacion" nombre-archivo="Respaldo" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { ESTADOS_TIPO_DOCUMENTO_PERSONA } from '../../comisiones/utils/constantes';
import ImagenPreview from './ImagenPreview.vue';
import PdfPreview from './PdfPreview.vue';

export default {
  name: 'DocumentoEstado',
  components: {
    ImagenPreview,
    PdfPreview,
  },
  props: {
    documentoPersona: {
      type: Object,
      required: true,
      validator: (value) => {
        return value.estadoRevision && Object.values(ESTADOS_TIPO_DOCUMENTO_PERSONA).includes(value.estadoRevision);
      },
    },
  },
  computed: {
    esPendiente() {
      return this.documentoPersona.estadoRevision === ESTADOS_TIPO_DOCUMENTO_PERSONA.PENDIENTE;
    },
    esAprobado() {
      return this.documentoPersona.estadoRevision === ESTADOS_TIPO_DOCUMENTO_PERSONA.APROBADO;
    },
    esRechazado() {
      return this.documentoPersona.estadoRevision === ESTADOS_TIPO_DOCUMENTO_PERSONA.RECHAZADO;
    },
    alertColor() {
      if (this.esPendiente) return 'orange';
      if (this.esAprobado) return 'success';

      return 'error';
    },
    alertIcon() {
      if (this.esPendiente) return 'mdi-alert-circle';
      if (this.esAprobado) return 'mdi-check-circle';

      return 'mdi-close-circle';
    },
    estadoTexto() {
      if (this.esPendiente) return 'Pendiente';
      if (this.esAprobado) return 'Aprobado';

      return 'Rechazado';
    },
    fechaRevision() {
      if (!this.documentoPersona.fechaHoraRevision) return null;
      return new Date(this.documentoPersona.fechaHoraRevision).toLocaleString('es-BO', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });
    },
    nombreRevisor() {
      const { revisor } = this.documentoPersona;
      if (!revisor) return null;
      return [revisor.nombres, revisor.primerApellido, revisor.segundoApellido].filter(Boolean).join(' ');
    },
    observaciones() {
      return this.documentoPersona.observaciones || null;
    },
  },
  data() {
    return {
      dialogoRespaldo: false,
      previsualizacion: null,
      esImagen: false,
      esPDF: false,
    };
  },
  methods: {
    verRespaldoGuardado() {
      const respaldo = this.documentoPersona?.archivoRespaldo;

      if (!respaldo?.file64) return;

      try {
        const byteCharacters = atob(respaldo.file64);
        const byteArray = new Uint8Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteArray[i] = byteCharacters.charCodeAt(i);
        }
        const blob = new Blob([byteArray], { type: respaldo.mimetype });

        this.previsualizacion = URL.createObjectURL(blob);
        this.esImagen = respaldo.mimetype.startsWith('image/');
        this.esPDF = respaldo.mimetype === 'application/pdf';
        this.dialogoRespaldo = true;
      } catch (error) {
        window.console.error('Error al cargar respaldo guardado:', error);
      }
    },
  },
};
</script>

<style scoped>
.text-caption {
  line-height: 1.5;
}
</style>
